/* Rechengenauigkeit fuer Vergleiche: ein Millionstel Euro bzw. Prozentpunkt.
   Die Groessen entstehen aus Divisionen und sind selten exakt darstellbar;
   ohne diese Schranke waere 55,0000000000001 % eine „Unterschreitung". */
const EPS = 1e-6;
/**
 * Die Marge, die ein Listenpreis nach Rabattbasis und Provision gegenueber
 * der Kostenbasis ergibt -- in Prozent.
 */
export function margeNachProvision(listenpreis, kostenbasis, provisionProzent, divisor) {
    const netto = listenpreis * divisor * (1 - provisionProzent / 100);
    return netto > 0 ? (1 - kostenbasis / netto) * 100 : -Infinity;
}
/** Erreicht dieser Listenpreis die Mindestmarge -- hart, ohne Toleranz? */
export function erreichtMindestmarge(listenpreis, kostenbasis, margeProzent, provisionProzent, divisor) {
    return margeNachProvision(listenpreis, kostenbasis, provisionProzent, divisor) >= margeProzent - EPS;
}
/** Kaufmaennisch auf die Schrittweite runden (PRODUCT_PRICE_V1.md 6.9). */
export function rundeAufSchritt(wert, schritt) {
    if (schritt <= 0)
        return wert;
    return Math.round(wert / schritt) * schritt;
}
export function preisstufen(kostenbasis, margeProzent, provisionProzent, divisor, rundungsschritt) {
    const nettoerloesNachMarge = kostenbasis / (1 - margeProzent / 100);
    const nettoverkaufspreis = nettoerloesNachMarge / (1 - provisionProzent / 100);
    const provision = nettoverkaufspreis * provisionProzent / 100;
    const listenpreisRoh = nettoverkaufspreis / divisor;
    let listenpreis = rundeAufSchritt(listenpreisRoh, rundungsschritt);
    let aufgerundet = false;
    /* Hoechstens ein Schritt: die kaufmaennische Rundung liegt nie mehr als
       einen halben Schritt unter dem Rohwert. Die Schleife ist die Absicherung,
       nicht der Regelfall. */
    while (rundungsschritt > 0
        && !erreichtMindestmarge(listenpreis, kostenbasis, margeProzent, provisionProzent, divisor)) {
        listenpreis = rundeAufSchritt(listenpreis + rundungsschritt, rundungsschritt);
        aufgerundet = true;
    }
    return {
        nettoerloesNachMarge, nettoverkaufspreis, provision,
        nettoerloesNachProvision: nettoverkaufspreis - provision,
        listenpreisRoh, listenpreis: Math.round(listenpreis * 1e6) / 1e6, aufgerundet,
    };
}
//# sourceMappingURL=preisstufen.js.map